import { AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";
import "./ErrorState.scss";

/**
 * Premium full-page error state component.
 *
 * Props:
 *  - icon       : lucide-react icon component (default AlertCircle)
 *  - title      : string — main heading
 *  - message    : string — supporting text
 *  - action     : { label, href?, onClick? } — primary CTA
 *  - secondaryAction : { label, href? } — optional back link
 */
export default function ErrorState({
  icon: Icon = AlertCircle,
  title = "Terjadi Kesalahan",
  message = "Sesuatu yang tidak terduga terjadi. Silakan coba lagi.",
  action,
  secondaryAction,
}) {
  return (
    <div className="err-state">
      <div className="err-state__card">
        <div className="err-state__accent-bar" />

        <div className="err-state__icon-wrap">
          <Icon size={40} strokeWidth={1.5} />
        </div>

        <h2 className="err-state__title">{title}</h2>
        <p className="err-state__message">{message}</p>

        {action && (
          <div className="err-state__actions">
            {action.href ? (
              <Link to={action.href} className="err-state__btn err-state__btn--primary">
                {action.label}
              </Link>
            ) : (
              <button
                className="err-state__btn err-state__btn--primary"
                onClick={action.onClick}
              >
                {action.label}
              </button>
            )}
          </div>
        )}

        {secondaryAction && (
          <div className="err-state__secondary">
            {secondaryAction.href ? (
              <Link to={secondaryAction.href} className="err-state__link">
                {secondaryAction.label}
              </Link>
            ) : (
              <button className="err-state__link" onClick={secondaryAction.onClick}>
                {secondaryAction.label}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
